import request from '@/utils/request'

// 查询入库单详情
export function queryInoutOrder(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/inoutOrder/queryInoutOrder',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 查询入库单商品列表
export function queryInoutOrderProduct(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/inoutOrder.queryInoutOrderProduct',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}